import { findAdresseProcheHandler } from './overrides/findAdresseProcheHandler'
import { getQuartiersHandler } from './overrides/getQuartiersHandler'
import { suggestAdressesHandler } from './overrides/suggestAdressesHandler'

export const handlers = [
  suggestAdressesHandler(),
  findAdresseProcheHandler(),
  getQuartiersHandler(),
]
